export default __webpack_public_path__ + "static/media/image-cover.a5161a1d.jpg";